import dynamic from "next/dynamic";
const CarouselTabsComponent = dynamic(()=>import("./carousel-tabs-component"));
import CarouselTabsConfig from "./carousel-tabs-config";
import CarouselTabsAdvancedConfig from "./carousel-tabs-advanced-config";
export default {
    CarouselTabsComponent,
    CarouselTabsConfig,
    CarouselTabsAdvancedConfig
};
